import axios from "axios";

// UI-07: a double click (or Enter + click) on a form sent the same create / update twice; most forms keep their
// button enabled while saving. While a write with the same method, URL and body is in flight, a second identical
// one shares its response instead of reaching the server.
// NEW-59: on a fast server the first save can finish before the second click (a slow double click, or a click
// again because nothing seemed to happen), and forms that stay open then saved twice (duplicate purchase orders).
// An identical write within REPEAT_MS of a successful one gets that result again instead of being sent.
const inflight = new Map();
const recent = new Map(); // key -> {at, response} of successful writes
const REPEAT_MS = 2000;

const bodyKey = (data) => {
  if (data == null) return "";
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    const parts = [];
    data.forEach((value, key) => {
      parts.push(`${key}=${value instanceof Blob ? `${value.name || "blob"}:${value.size}` : value}`);
    });
    return parts.join("&");
  }
  return typeof data === "string" ? data : JSON.stringify(data);
};

export const installSubmitGuard = () => {
  const send = axios.getAdapter(axios.defaults.adapter);
  axios.defaults.adapter = (config) => {
    const method = (config.method || "get").toLowerCase();
    if (method === "get" || method === "options" || method === "head") {
      return send(config);
    }
    const key = `${method} ${config.baseURL || ""}${config.url} ${bodyKey(config.data)}`;
    const now = Date.now();
    recent.forEach((v, k) => now - v.at >= REPEAT_MS && recent.delete(k));
    if (inflight.has(key)) {
      return inflight.get(key);
    }
    if (recent.has(key)) {
      return Promise.resolve(recent.get(key).response);
    }
    const request = Promise.resolve(send(config))
      .then((response) => {
        if (response && response.status < 400) recent.set(key, { at: Date.now(), response });
        return response;
      })
      .finally(() => inflight.delete(key));
    inflight.set(key, request);
    return request;
  };
};
